
import {Component, Vue} from 'vue-property-decorator';
import {readAdminForms} from '@/store/admin/getters';

@Component({})
export default class ImportFormSettings extends Vue {
  private dialog: boolean = false;
  // private importDefault: boolean = false;
  private selectedItem: any = null;

  public importFunction(val) {
    // if (this.importDefault) {
    //   console.log(this.defaultSettings)
    //   this.$emit('import-function', this.defaultSettings);
    // } else
    if (!this.selectedItem) {
      return;
    }
    this.dialog = false;
    this.$emit('import-function', val);
  }

  // @Watch('importDefault')
  // private changeImportDefault(val, oldVal) {
  //   if (this.importDefault) {
  //     this.selectedRole = null;
  //   }
  // }

  private get forms() {
    return readAdminForms(this.$store);
  }


}
